import { render, staticRenderFns } from "./ArchiveDownloadLink.vue?vue&type=template&id=5f2c4922&scoped=true&"
import script from "./ArchiveDownloadLink.vue?vue&type=script&lang=js&"
export * from "./ArchiveDownloadLink.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveDownloadLink.vue?vue&type=style&index=0&id=5f2c4922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c4922",
  null
  
)

export default component.exports